import e from "../../../../utilities/tw.js";
const a = {
  container: e`relative flex items-center justify-center`,
  leftBar: e`absolute bottom-0 left-0 w-[28%] animate-syfLoaderLeftBar`,
  middleBar: e`absolute w-[28%] animate-syfLoaderMiddleBar`,
  rightBar: e`absolute right-0 top-0 w-[28%] animate-syfLoaderRightBar`
};
export {
  a as syfLoaderStyles
};
